import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
const beforeItems = ['Le doy balanceado todos los días sin saber si realmente le hace bien', 'Sus gases, pelo opaco, poca energía y que se rasque o lama las patas todo el día me preocupan pero no sé qué hacer', 'Quiero cambiar su alimentación pero tengo miedo de equivocarme y hacerle daño'];
const afterItems = ['Sé exactamente qué le doy y por qué le hace bien', 'Lo veo con más energía, pelo brillante, sin problemas digestivos y sin rascarse ni lamerse las patas', 'Me siento una dueña consciente que sabe cómo cuidar a su perro de verdad'];
export function BeforeAfterSection() {
  return <section className="py-10 md:py-14 px-4 bg-white" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6 md:mb-8" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal font-serif leading-tight" data-id="element-23">
            La alimentación <span className="text-primary" data-id="element-24">lo cambia todo</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-3 items-start" data-id="element-25">
          {/* ANTES Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-red-50 rounded-2xl overflow-hidden border border-red-100" data-id="element-26">
            {/* Label */}
            <div className="px-4 pt-3 pb-2" data-id="element-27">
              <span className="inline-block px-3 py-1 bg-red-500 text-white text-xs font-extrabold uppercase tracking-wider rounded-full" data-id="element-28">
                Antes
              </span>
            </div>

            {/* Image */}
            <div className="w-full px-3 pb-2" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/9hNDh9noRjnqTapeMDxbbb/ANTES.png" alt="Antes - perro sin energía con alimento procesado" className="w-full object-contain rounded-xl" data-id="element-30" />
            </div>

            {/* List */}
            <div className="px-4 py-3" data-id="element-31">
              <ul className="space-y-1.5" data-id="element-32">
                {beforeItems.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-33">
                    <XCircleIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-34" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-35">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Arrow Divider */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.2
        }} className="flex justify-center items-center py-1 md:py-0 md:self-center" data-id="element-36">
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center shadow-lg" data-id="element-37">
              {/* Down arrow on mobile, right arrow on desktop */}
              <svg className="w-5 h-5 text-white md:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-38">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-39" />
              </svg>
              <ArrowRightIcon className="w-5 h-5 text-white hidden md:block" data-id="element-40" />
            </div>
          </motion.div>

          {/* DESPUÉS Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="bg-green-50 rounded-2xl overflow-hidden border border-green-200" data-id="element-41">
            {/* Label */}
            <div className="px-4 pt-3 pb-1" data-id="element-42">
              <span className="inline-block px-3 py-1 bg-primary text-white text-xs font-extrabold uppercase tracking-wider rounded-full" data-id="element-43">
                Después
              </span>
            </div>

            {/* Image */}
            <div className="w-full px-2" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/wuWvAeMDL6Nixr1PeH9gy4/DESPUES.png" alt="Después - perro feliz y activo con comida natural" className="w-full max-h-[200px] md:max-h-[240px] object-contain" data-id="element-45" />
            </div>

            {/* List */}
            <div className="px-4 py-3" data-id="element-46">
              <ul className="space-y-1.5" data-id="element-47">
                {afterItems.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-48">
                    <CheckCircle2Icon className="w-4 h-4 text-primary flex-shrink-0" data-id="element-49" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-50">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}